import React, { useEffect, useContext, createContext } from 'react';
import { getPendingJobs } from 'utils/network/http';
import { useAuth } from 'hooks/useAuth/useAuth';
import config from 'utils/constants/config';
import usePolling from 'hooks/usePolling/usePolling';
import useFetchData from 'hooks/useFetchData/useFetchData';

export const pendingJobsContext = createContext();

export const ProvidePendingJobs = ({ pollingActivated, children }) => {
  const pendingJobs = useProvidePendingJobs(pollingActivated);
  return (
    <pendingJobsContext.Provider value={pendingJobs}>
      {children}
    </pendingJobsContext.Provider>
  );
};

export const usePendingJobs = () => {
  return useContext(pendingJobsContext);
};

const useProvidePendingJobs = pollingActivated => {
  const { profile } = useAuth();
  const { loading, error, data, fetchData, silentFetchData } = useFetchData({
    fetchFunc: getPendingJobs
  });

  const { startPolling, cancelPolling, isPolling } = usePolling({
    fetchFunc: silentFetchData,
    delay: config.FAST_POLLING_DELAY
  });

  useEffect(() => {
    if (!data && profile && !error && !loading) {
      fetchData();
      if (pollingActivated) {
        startPolling();
      }
    }
    if (isPolling && !pollingActivated) {
      cancelPolling();
    }
  }, [
    data,
    fetchData,
    profile,
    error,
    loading,
    startPolling,
    cancelPolling,
    isPolling,
    pollingActivated
  ]);

  return {
    pendingJobs: data,
    loading,
    error,
    silentFetchPendingJobs: silentFetchData,
    startPollingPendingJobs: startPolling,
    cancelPollingPendingJobs: cancelPolling
  };
};
